class HighlightHoverVideo extends HTMLElement {
  constructor() {
    super();
    this.card = null;
    this.video = null;
    this.sourcesLoaded = false;
    this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  }

  connectedCallback() {
    this.card = this.closest('.highlight-card') || this;
    this.video = this.querySelector('video');

    if (!this.video || !this.hoverQuery.matches) return;

    this.card.addEventListener('pointerenter', this.playVideo);
    this.card.addEventListener('pointerleave', this.pauseWhenIdle);
    this.card.addEventListener('focusin', this.playVideo);
    this.card.addEventListener('focusout', this.pauseWhenIdle);
  }

  disconnectedCallback() {
    if (!this.card) return;

    this.card.removeEventListener('pointerenter', this.playVideo);
    this.card.removeEventListener('pointerleave', this.pauseWhenIdle);
    this.card.removeEventListener('focusin', this.playVideo);
    this.card.removeEventListener('focusout', this.pauseWhenIdle);
  }

  loadSources() {
    if (this.sourcesLoaded || !this.video) return;

    for (const source of this.video.querySelectorAll('source[data-video-source]')) {
      source.setAttribute('src', source.dataset.videoSource);
    }

    this.video.load();
    this.sourcesLoaded = true;
  }

  playVideo = () => {
    if (!this.video || !this.hoverQuery.matches) return;

    this.loadSources();
    const playPromise = this.video.play();

    if (playPromise) {
      playPromise.catch(() => undefined);
    }
  };

  pauseVideo = () => {
    if (!this.video) return;

    this.video.pause();

    try {
      this.video.currentTime = 0;
    } catch {
      // Some browsers reject seeking before metadata is available.
    }
  };

  pauseWhenIdle = () => {
    window.requestAnimationFrame(() => {
      if (!this.card?.matches(':hover') && !this.card?.contains(document.activeElement)) {
        this.pauseVideo();
      }
    });
  };
}

if (!customElements.get('highlight-hover-video')) {
  customElements.define('highlight-hover-video', HighlightHoverVideo);
}
